module.exports = __webpack_public_path__ + "static/media/DFKI_Logo.11f30071.png";